import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useForm, useWatch } from "react-hook-form";
import { isEmpty } from "lodash";
import { Button, message, Spin } from "antd";
import dayjs from "dayjs";
import TextArea from "../../Components/CommonCommponents/TextArea";
import RangePicker from "../../Components/CommonCommponents/RangePicker";
import DatePicker from "../../Components/CommonCommponents/DatePicker";
import Checkbox from "../../Components/CommonCommponents/Checkbox";
import Input from "../../Components/CommonCommponents/Input";
import CandodateService from "../../Service.js/CandidateService";
import toast from "react-hot-toast";

export default function RequiredExperienceModal(props) {
  const { isEditForm, close, experiences, editIndex, candidateId } = props;
  const params = useParams();

  const defaultValues = {
    company: isEditForm ? props?.details?.company : "",
    location: isEditForm ? props?.details?.location : "",
    designation: isEditForm ? props?.details?.designation : "",
    isCurrentCompany: isEditForm ? props?.details?.is_current_company : false,
    workedFrom: isEditForm ? dayjs(props?.details?.worked_from) : "",
    duration: isEditForm
      ? [dayjs(props?.details?.worked_from), dayjs(props?.details?.worked_till)]
      : [],
    responsibilities: isEditForm ? props?.details?.responsibilities : "",
  };

  const {
    handleSubmit,
    control,
    setValue,
    register,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues,
    mode: "all",
  });
  const DEFAULT_ERROR_MESSAGE =
    "Something went wrong, Please try again after sometime";
  const isCurrentCompany = useWatch({ control, name: "isCurrentCompany" });
  const [messageApi, contextHolder] = message.useMessage();

  const sendData = async (data) => {
    await CandodateService.addExperience(data)
      .then(
        (oResponse) => {
          console.log("oResponse", oResponse);
          toast.success("Successfully Added!");
          props?.setEnable(true);
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
        toast.error("Failed To Add");
      });
  };

  const updateData = async (data) => {
    await CandodateService.updateExperience(data, props?.details?.id)
      .then(
        (oResponse) => {
          console.log("oResponse", oResponse);
          toast.success("Successfully Added!");

          props.close();
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
        toast.error("Failed To Add");
      });
  };
  const onSubmit = async (fields) => {
    try {
      const {
        company,
        designation,
        isCurrentCompany,
        responsibilities,
        location,
      } = fields;

      const data = {
        candidate: candidateId,
        company,
        designation,
        is_current_company: isCurrentCompany,
        responsibilities,
        location,
      };

      if (isCurrentCompany) {
        data["worked_from"] = dayjs(fields.workedFrom).format("YYYY-MM-DD");
      } else {
        data["worked_from"] = dayjs(fields.duration[0]).format("YYYY-MM-DD");
        data["worked_till"] = dayjs(fields.duration[1]).format("YYYY-MM-DD");
      }

      // console.log(experiences, "ENTERRRRRRRRR", data);
      // if (isEditForm) {
      //   await editExperience({
      //     body: data,
      //     experienceId: props?.details?.id,
      //   });
      // } else {
      //   await addExperience(data);
      // }
      if (isEditForm) {
        updateData(data);
      } else {
        sendData(data);
      }
      close();
    } catch (error) {
      console.error("Submission Error", error);
    }
  };

  return (
    <div className="w-full px-10 pt-8">
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col">
        <div className="w-full">
          <Input
            label="Company"
            name="company"
            control={control}
            rules={{
              required: "This Field is Required",
              pattern: {
                value: /[a-zA-Z]/g,
                message: "Invalid Company Name",
              },
            }}
            placeholder="Name"
          />
        </div>
        {/* <div className="w-full">
          <Input
            label="Location"
            name="location"
            control={control}
            rules={{
              required: "This Field is Required",
              // pattern: {
              //   value: /[a-zA-Z]/g,
              //   message: 'Invalid Location Name',
              // },
            }}
            placeholder="Name"
          />
        </div> */}
        <div className="w-full">
          <Input
            label="Designation"
            name="designation"
            placeholder="Title/Role Name"
            control={control}
            rules={{
              required: "This Field is Required",
              pattern: {
                value: /[a-zA-Z]/g,
                message: "Please enter letters only",
              },
            }}
          />
        </div>
        <div className="w-full">
          <Checkbox
            label="Current Company?"
            name="isCurrentCompany"
            control={control}
            showUpperLabel={false}
          />
        </div>
        <div className="w-full">
          {isCurrentCompany ? (
            <DatePicker
              label="Starting Date"
              name="workedFrom"
              control={control}
              noTextInput
              rules={{
                required: "Please Choose a Date",
              }}
              disableFutureDays
            />
          ) : (
            <RangePicker
              label="Duration"
              name="duration"
              control={control}
              rules={{
                required: "Please Choose a Date",
              }}
              disableFutureDays
            />
          )}
        </div>
        <div>
          <div>responsibilities</div>
          <TextArea
            rows={4}
            name="responsibilities"
            control={control}
            className="h-[250px]"
            rules={
              {
                //   required: 'This field is required',
              }
            }
          />
        </div>

        <div className="flex ml-auto mt-4 gap-4">
          {contextHolder}
          <Button
            isCancel
            htmlType="submit"
            disabled={false}
            children="Cancel"
            onClick={close}
          />
          <Button type="primary" htmlType="submit" disabled={false}>
            Add
          </Button>
        </div>
      </form>
    </div>
  );
}
